import React, { useContext } from 'react'
import Classes from '../Cart.module.css'
import TableRow from '../TableRow';
import { CartContext } from '../../../Context/CartContext';
import { scrollToElement } from '../../../utils/scrollToElement';
import useScreenWidth from '../../../Hooks/useScreenWidth';
const CloseIcon = () => (
    <svg
        fill="black"
        height="22px"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
    >
        <path
            fillRule="evenodd"
            d="M7.293 7.293a1 1 
                  0 011.414 0L16 14.586l7.293-7.293a1 1 
                  0 011.414 1.414L17.414 16l7.293 
                  7.293a1 1 0 01-1.414 1.414L16 
                  17.414l-7.293 7.293a1 1 
                  0 01-1.414-1.414L14.586 
                  16 7.293 8.707a1 1 0 
                  010-1.414z"
            clipRule="evenodd"
        ></path>
    </svg>
)

export default function ProductsInfo({ handleOrderNow, setopenCart, setIsShowBillingInfo }) {
    const {
        cartItems,
        removeFromCart,
        updateQuantity,
        getCartTotal,
        updateSize,
        getCartCount,
        clearCart
    } = useContext(CartContext);

    const isLessthan600 = useScreenWidth() <= 600;

    const goToNextPage = () => {
        setIsShowBillingInfo(true);
        if (isLessthan600) {
            scrollToElement('cart-top', -100)
        }
    }

    return (
        <>
            <div className={Classes.header}>
                <div className={Classes.flex}>
                    <h3>My Bag</h3>
                    <h5>({getCartCount()} items)</h5>
                </div>
                <div className={Classes.flex}>
                    <button
                        className={Classes.clearCartBtn}
                        type='button'
                        onClick={clearCart}
                    >
                        <h5> Clear Cart </h5>
                    </button>
                    <div className={Classes.closeBtn} onClick={() => { setopenCart(false) }}>
                        <CloseIcon />
                    </div>
                </div>
            </div>
            {getCartCount() > 0 ?
                <>
                    <div className={Classes.table}>
                        <div className={Classes.tableHeader}>
                            <div className={Classes.tableHeaderItem}><h5>Product</h5></div>
                            <div className={`${Classes.tableHeaderItem} ${Classes.flexBetween}`}><h5>Price</h5></div>
                            <div className={`${Classes.tableHeaderItem} ${Classes.flexBetween}`}><h5>Quantity</h5></div>
                            <div className={`${Classes.tableHeaderItem} ${Classes.flexEnd}`}><h5>Total</h5></div>
                        </div>
                        <div className={Classes.tableBody}>
                            {cartItems?.map(item => (
                                <TableRow
                                    key={`${item?.id}-${item?.selectedSize}-${item?.selectedImage}`}
                                    item={item}
                                    onRemove={() => removeFromCart(item.id, item.selectedImage)}
                                    onQuantityChange={(newQuantity) => updateQuantity(item.id, item.selectedImage, newQuantity)}
                                    onSizeChange={(productId, selectedImage, newSize) => updateSize(productId, selectedImage, newSize)}
                                />
                            ))}
                        </div>
                    </div>
                    <div className={Classes.totalCon}>
                        <div className={Classes.totalLineItem}>
                            <h5 className={Classes.itemTitle}>Subtotal</h5>
                            <h5>AED {getCartTotal()}</h5>
                        </div>
                        <div className={Classes.totalLineItem}>
                            <h5 className={Classes.itemTitle}>Shipping</h5>
                            <h5>Free</h5>
                        </div>
                        <div className={Classes.totalLineItem} style={{ border: 'none' }}>
                            <h5 className={Classes.itemTitle}>Grand total</h5>
                            <h4>AED {getCartTotal()}</h4>
                        </div>
                    </div>
                    <button
                        className={Classes.checkoutBtn}
                        onClick={goToNextPage}
                        type='button'
                    >
                        <h5>Checkout</h5>
                    </button>
                </>
                :
                <div className={Classes.emptyCart} >
                    <h4>Empty cart</h4>
                    <h5>There is no item added in cart yet...</h5>
                </div>
            }
        </>
    )
}
